export const APP_TOKEN_HANDSHAKE_ROUTES = [
  '/redirect/payment',
  '/redirect/plan'
];

/**
 * On the app -> web redirect routes, a short lived `token` from the query is exchanged
 * for a fresh `accessToken` cookie before moving to checkout. Authenticated calls made
 * before that exchange completes go out with whatever stale cookie the browser already
 * has, and the 401 they get back signs the user out — wiping the new cookie as well.
 */
const isAppTokenHandshakePending = () => {
  if (typeof window === 'undefined') return false;

  const { pathname, search } = window.location;
  const route = pathname.replace(/\/+$/, '');
  if (!APP_TOKEN_HANDSHAKE_ROUTES.includes(route)) return false;

  const params = new URLSearchParams(search);
  return params.get('source') === 'app';
};

export default isAppTokenHandshakePending;
